export const CHECKOUT_LABELS = 'checkout';

export const lblSfsAddressCta = 'lbl_sfs_address_cta';
export const lblSfsShippingCta = 'lbl_sfs_shipping_cta';
export const lblSfsGiftserviceCta = 'lbl_sfs_giftservice_cta';
export const lblSfsSflCta = 'lbl_sfs_sfl_cta';

const SaveForLaterModalLabels = {
  checkout: {
    shipping: {
      [lblSfsAddressCta]: 'Change Address',
      [lblSfsShippingCta]: 'Select Standard Shipping',
      [lblSfsGiftserviceCta]: 'Update Gift Services',
      [lblSfsSflCta]: 'Save Items For Later & Continue',
    },
  },
};
export default SaveForLaterModalLabels;
